export const paths = {
  detail: '/user_invitations/:token',
};
